import { Currencies, CurrenciesAction } from '@.pages';

import { RoutePage } from '../types';

export const CurrenciesPage: RoutePage = {
    url: 'currencies',
    component: <Currencies />,
    permissions: {
        entity: 'Currencies',
        right: 'read',
    },
    sidebar: {
        name: 'Currencies',
    },
    children: [
        {
            url: ':id',
            children: [
                {
                    url: 'edit',
                    component: <CurrenciesAction edit />,
                    permissions: {
                        entity: 'Currencies',
                        right: 'update',
                    },
                },
            ],
        },
        {
            url: 'add',
            component: <CurrenciesAction />,
            permissions: {
                entity: 'Currencies',
                right: 'create',
            },
        },
    ],
};
